const richText = document.querySelector('.rich-text')
const firstImage = richText?.querySelector('img')
if (firstImage) {
	firstImage.classList.add('max-md:hidden')
	document
		.querySelector('.blog-mobile-first-image')
		.setAttribute('src', firstImage.getAttribute('src'))
}

export default firstImage
